import { DL_ITEM_LIST_YMAL } from './gtmAnalyticsConstants';
import { getProductData, reduceProductFields, replaceSpecialChars } from './gtmAnalyticsUtils';
import { dlSelectItem, dlViewItemList, getBasicListProps } from './productListAnalytics';

const { locale, pageType } = window.inlineGlobalConfig;

export function dlSelectCrossSellItem(product, index) {
  const listName = `${pageType} ${DL_ITEM_LIST_YMAL}`;
  dlSelectItem(product, { index, ...getBasicListProps(listName) });
}

function dlViewCrossSellItemList(products) {
  const listName = `${pageType} ${DL_ITEM_LIST_YMAL}`;
  dlViewItemList(products, { ...getBasicListProps(listName) });
}

function dlTrackCrossSellProducts(crossSellProducts, title, id) {
  const observer = new IntersectionObserver(handleIntersect, {
    threshold: 0.9,
  });
  const crossSellRows = document.querySelectorAll(`.js-tracking-${id}-crossSell-rows:not([data-analytics-attached])`);
  [...crossSellRows].forEach(row => {
    observer.observe(row);
    row.setAttribute('data-analytics-attached', true);
  });

  let nrOfTrackedProducts = 0;

  function handleIntersect(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        try {
          const rowProducts = [...entry.target.children].map(productElement =>
            crossSellProducts.find(product => product.id === productElement.getAttribute('data-sku'))
          );

          pushProductsAnalytics(rowProducts, replaceSpecialChars(title), nrOfTrackedProducts);
          dlViewCrossSellItemList(rowProducts);
          observer.unobserve(entry.target);
          nrOfTrackedProducts += rowProducts.length;
        } catch (error) {
          console.error(error);
        }
      }
    });
  }
}

function pushProductsAnalytics(rowProducts, title, nrOfPushedProducts) {
  const productsAnalytics = rowProducts.map((product, index) =>
    Object.assign(getProductData({ ...product, productCode: product.id }), {
      dimension14: title,
      position: nrOfPushedProducts + index,
      list: `product detail - ${title}`,
    })
  );

  const dataLayerInfo = {
    event: 'visitor interaction',
    interaction_name: 'product impression',
    ecommerce: {
      currencyCode: locale.currentCurrency,
      impressions: reduceProductFields(productsAnalytics),
    },
  };

  window.dataLayer.push(dataLayerInfo);
}

export default dlTrackCrossSellProducts;
